export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd418572b96c02027f3157076495da8adb3237df7&name=fetchTypeahead!'